import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToasterServiceService } from '../service/toaster.service';
import { Location } from '@angular/common';
import { LocalStorageService } from '../service/local-storage.service';
import { MainService } from '../service/main.service';
import { ApiUrls } from '../apiRouts';
import { Router } from '@angular/router';
import { noWhitespaceValidator } from '../service/must-match.service';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrl: './notification.component.scss'
})
export class NotificationComponent implements OnInit{
  notificationForm: any = FormGroup;
  user_id: string | null | undefined;
  submitted = false;
  userSelectOptions: any = [];

  constructor(
    private location: Location,
    private fb: FormBuilder,
    private localStorageService: LocalStorageService,
    private mainService: MainService,
    private router: Router,
    private toasterService: ToasterServiceService) {
    this.user_id = JSON.parse(localStorageService.getItem("loginData") || '{}').user_id;
    this.notificationForm = this.fb.group({
      notification_title: ['', [Validators.required]],
      description: ['', [Validators.required]],
      userSelect: ['', [Validators.required]],
    })
  }

  get f() {
    return this.notificationForm.controls;
  }

  goBackToPrevPage() {
    this.location.back();
  }

  ngOnInit(): void {
    this.getUserTypeList();
  }

  getUserTypeList() {
    this.mainService.getApi(ApiUrls.userTypeList).subscribe((res: any) => {
      if (res.status == 1) {
        this.userSelectOptions = res.user_type;
        let jsonObject = {
          "user_type_id": "0",
          "user_type": "સભ્યો",
          "is_active": 1
        };
        this.userSelectOptions.push(jsonObject);
      }
    });
  }

  submit() {
    this.submitted = true;
    if (this.notificationForm.valid) {
      //let selectedUserTypes = this.notificationForm.value.userSelect.map((value: string) => Number(value));
      let data = {
        notification_id: 0,
        notification_title: this.notificationForm.value.notification_title,
        description: this.notificationForm.value.description,
        created_by: Number(this.localStorageService.getItem('user_id')),
        //to_user_type_id: selectedUserTypes,     
        to_user_type_id: Number(this.notificationForm.value.userSelect),
        Action: 'INSERT',
      };
      this.mainService.postApi(ApiUrls.addNotification, data, 1).subscribe((res: any) => {
        if (res.status == 1) {
          this.notificationForm.reset();
          this.submitted = false;
          this.router.navigate(["/dashboard"]);
          this.toasterService.toastSuccess(res.response);
          this.mainService.triggerProfileData(1);
        } else {
          this.toasterService.toastError(res.response);          
        }
      })
    }
  }

}
